// Site-wide tool-hiding: injects CSS that hides any <a href> belonging to an
// admin-hidden tool (paths resolved server-side, see routes/user_tools.py
// TOOL_PATHS) or any [data-tool-slug] element, everywhere on the site —
// Dashboard grid + panels, Navbar "More" menu, mobile menu, promo widgets.
// Mounted once in the app Layout; this is the only hidden-tools stylesheet.
// Pure CSS (no inline style mutation) so it un-hides cleanly on logout/user switch.
import { useHiddenTools } from '../hooks/useHiddenTools';

const clean = (s, re) => String(s).replace(re, '');

export default function HiddenToolsStyleInjector() {
  const { hidden, hiddenPaths } = useHiddenTools();
  if (!hiddenPaths.length && !hidden.length) return null;

  const pathRules = hiddenPaths.map((raw) => {
    const p = clean(raw, /[^a-z0-9/_-]/gi);
    if (!p || p === '/') return '';
    return `a[href="${p}"], a[href^="${p}?"], a[href^="${p}#"], a[href="${p}/"]`;
  }).filter(Boolean);
  const slugRules = hidden.map((raw) => {
    const s = clean(raw, /[^a-z0-9-]/gi);
    return s ? `[data-tool-slug="${s}"]` : '';
  }).filter(Boolean);

  const css = [...pathRules, ...slugRules].map((sel) => `${sel} { display: none !important; }`).join('\n');
  return <style data-testid="hidden-tools-style" dangerouslySetInnerHTML={{ __html: css }} />;
}
